"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WriterHelper = void 0;
var WriterHelper = (function () {
    function WriterHelper() {
    }
    WriterHelper.convertToHexString = function (value) {
        return value.toString(16);
    };
    WriterHelper.getValueFromTables = function (table, value, defaultValue) {
        var res = table.exportMap[value];
        return res !== undefined ?
            res.mlValue.openXmlValue :
            table.exportMap[defaultValue].mlValue.openXmlValue;
    };
    WriterHelper.getValueFromTablesExplicitDefault = function (table, value, defaultValue) {
        var res = table.exportMap[value];
        return res !== undefined ?
            res.mlValue.openXmlValue :
            defaultValue;
    };
    return WriterHelper;
}());
exports.WriterHelper = WriterHelper;
